import React, { useEffect, useState } from 'react';
import './HomeScreen.css';
import './AdminHomeScreen.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {mainUrl} from './url';
import {useNavigate} from 'react-router-dom';
import moment from 'moment-timezone';
import axios from 'axios';
import { useAuth } from '../Auth';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import AdminDigitArrLimit from './AdminDigitArrLimit';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function LimitEachDigit() {
  const navigate = useNavigate();
  const {authTokens, userType} = useAuth()
  useEffect(() => {
    const backToLogin = () => {
      navigate('/')
    }
    if(!authTokens){
      backToLogin()
    }
  },[authTokens, navigate])
  const [limitAmount, setLimitAmount] = useState('0')
  const [open, setOpen] = useState(false);
  const [currentDigit, setCurrentDigit] = useState([])
  const [getEachLimit, setGetEachLimit] = useState([])
  const [newAmount, setNewAmount] = useState(0)

  const handleClickOpen = (digit) => {
    setCurrentDigit((prev) => {
      // If digit already exists, remove it
      if (prev.includes(digit)) {
        return prev.filter((item) => item !== digit);
      }

      // Otherwise add it
      return [...prev, digit];
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  var inputDate = moment().tz('Asia/Yangon').format();

  const numarray = Array(100).fill(0).map((n, i) => { 
    if((n + i) < 10){
      return '0'+String(n+i)
    } else {
      return String(n + i)
    }
  })

  const [updateLimit, setUpdateLimit] = useState(0)
  useEffect(() => {
		let isSubscribed = true;
        if(isSubscribed){
            (async function(){
                try{
                    await axios.all([
                      axios({
                        method:'get',
                        url: mainUrl+'api.php?op=getEachLimitAll&adminid='+userType?.id
                      })
                    ]).then(response => {
                        setGetEachLimit(
                          Array.isArray(response?.[0]?.data?.data?.result)
                            ? response[0].data.data.result
                            : []
                        )
                    })
                } catch (error) {
                    
                }
            })()
        }
		return () => {isSubscribed = false}
  }, [userType?.id, updateLimit])

  useEffect(() => {
		let isSubscribed = true;
        if(isSubscribed){
            (async function(){
                try{
                    await axios.all([
                      axios({
                        method:'get',
                        url: mainUrl+'api.php?op=getLimitAllDigit&adminid='+userType?.id
                      })
                    ]).then(response => {
                        var data = response?.[0]?.['data']['data']['result']
                        setLimitAmount(data?.[0]?.limit_amount === undefined || data===null?'0':data?.[0]?.limit_amount)
                    })
                } catch (error) {
                    
                }
            })()
        }
		return () => {isSubscribed = false}
  }, [userType?.id])

  // new design get data from history 

  const SaveEachLimit = async () => {
    setOpen(false);

    const saveLimitUrl = mainUrl + 'api.php?op=saveLimitEachDigit';
    const updateLimitUrl = mainUrl + 'api.php?op=updateEachLimit';

    if (currentDigit?.length > 0) {
      try {
        await Promise.all(
          currentDigit.map((digit) => {
            if (getEachLimit.some(item => item.digit === digit)) {
              return fetch(updateLimitUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                  digit: digit,
                  amount: newAmount,
                  adminid: userType?.id,
                }),
              }).then(() => {
                setUpdateLimit(prev => prev + 1)
              })
            } else {
              return fetch(saveLimitUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                  digit: digit,
                  amount: newAmount,
                  adminid: userType?.id,
                  date: inputDate,
                }),
              }).then(() => {
                setUpdateLimit(prev => prev + 1)
              })
            }
          })
        );

        setGetEachLimit((prev) => prev + 1);

      } catch (error) {
        console.error("Error saving limits:", error);
      }
    }
  };

  const DeleteLimitDigit = async(id) => {
    if(id !== ''){
      let delUserUrl = mainUrl+'api.php?op=limiteachdigitdelete&adminid='+id
      await axios({
        method: 'get',
        url: delUserUrl
      }).then(() => {
        //setDelMes('Agent အကောင့်ဖျက်ပီးပါပီ')
        setUpdateLimit(updateLimit+1)
        //setOpen(false)
      })
    }
  }

  return (
    <div className='adminScreen'>
      <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
      >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{fontSize:14, fontFamily:'mmfont'}}>
          ပမာဏ သတ်မှတ်မည်
          </DialogTitle>
          <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
          }}
          >
          <CloseIcon />
          </IconButton>
          <div style={{width: "200px",
        overflowWrap: "break-word", marginLeft:20, marginRight:20}}>
            <p >{currentDigit?.join(', ')} </p>
          </div>
          <DialogContent>
              <TextField
              size='small'
              autoComplete={false}
              id="outlined-basic" variant="outlined" 
              value={newAmount}
              type="number"
              placeholder='ပမာဏ'
              onChange={(e) => setNewAmount(e.target.value)}
              />
          </DialogContent>
          <DialogActions>
          <Button style={{fontFamily:'mmfont'}} autoFocus onClick={() => SaveEachLimit()}>
              သိမ်းမည်
          </Button>
          </DialogActions>
      </Dialog>
      <div className='adminTop'>
        <Button
        onClick={() => navigate('/home')}
        style={{textDecoration:'none', backgroundColor:'white',
        color:'black', textTransform:'capitalize', padding:'1px 5px'}}
        >
          Back
        </Button>
        <Button
        onClick={() => setCurrentDigit([])}
        style={{textDecoration:'none', backgroundColor:'white',
        color:'black', textTransform:'capitalize', padding:'1px 5px', fontFamily:'mmfont'}}
        >
          အစပြန်ရွေးမည်
        </Button>
        <Button
        onClick={handleOpen}
        style={{textDecoration:'none', backgroundColor:'white',
        color:'black', textTransform:'capitalize', padding:'1px 5px', fontFamily:'mmfont'}}
        disabled={currentDigit?.length < 1}
        >
          ပမာဏ သတ်မှတ်မည်
        </Button>
        <Button
        onClick={() => DeleteLimitDigit(userType?.id)}
        style={{textDecoration:'none', backgroundColor:'white',
        color:'black', textTransform:'capitalize', padding:'1px 5px', fontFamily:'mmfont'}}
        disabled={getEachLimit?.length < 1}
        >
          မူလ limit အတိုင်းပြန်ထားမည်
        </Button>
      </div>
      <div className='wholeHomeScreen'>
        <div className='tableWhole' style={{margin:20}}>
            <AdminDigitArrLimit
            numarray = {numarray}
            limit = {limitAmount}
            handleClickOpen={handleClickOpen}
            currentDigit = {currentDigit}
            firstDigit = {-1}
            lastDigit = {20}
            limitArr = {getEachLimit}
            />
            <AdminDigitArrLimit
            numarray = {numarray}
            limit = {limitAmount}
            handleClickOpen={handleClickOpen}
            currentDigit = {currentDigit}
            firstDigit = {20}
            lastDigit = {40}
            limitArr = {getEachLimit}
            />
            <AdminDigitArrLimit
            numarray = {numarray}
            limit = {limitAmount}
            handleClickOpen={handleClickOpen}
            currentDigit = {currentDigit}
            firstDigit = {40}
            lastDigit = {60}
            limitArr = {getEachLimit}
            />
            <AdminDigitArrLimit
            numarray = {numarray}
            limit = {limitAmount}
            handleClickOpen={handleClickOpen}
            currentDigit = {currentDigit}
            firstDigit = {60}
            lastDigit = {80}
            limitArr = {getEachLimit}
            />
            <AdminDigitArrLimit
            numarray = {numarray}
            limit = {limitAmount}
            handleClickOpen={handleClickOpen}
            currentDigit = {currentDigit}
            firstDigit = {80}
            lastDigit = {100}
            limitArr = {getEachLimit}
            />
          </div> 
      </div>
    </div>
  )
}

export default LimitEachDigit